import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  linksContainer: {
    display: "flex",
    justifyContent: "flex-start",
    width: "100%",
    "@media (max-width: 600px)": {
      flexDirection: "column"
    }
  },
  linksColumn: {
    "& + $linksColumn": {
      marginLeft: 140
    },
    "@media (max-width: 1200px)": {
      "& + $linksColumn": {
        marginLeft: 60
      }
    },
    "@media (max-width: 660px)": {
      "& + $linksColumn": {
        marginLeft: 30
      }
    }
  },
  linksColumnTitle: {
    fontSize: 14,
    lineHeight: 1.5,
    fontWeight: 700,
    textTransform: "uppercase",
    color: "#FFFFFF"
  },
  linksColumnItems: {
    marginTop: 24,
    "@media (max-width: 600px)": {
      marginTop: 16
    }
  },
  linksColumnItem: {
    listStyle: "none",
    "@media (max-width: 600px)": {
      marginLeft: 16
    },
    "& + $linksColumnItem": {
      marginTop: 8,
      "@media (max-width: 600px)": {
        marginTop: 16
      }
    }
  }
  ,
  linksColumnLink: {
    fontSize: 16,
    lineHeight: 1.5,
    fontWeight: 500,
    color: "#FFFFFF",
    textDecoration: "none",
    "&:hover, &:focus": {
      textDecoration: "underline",
      color: "#FFFFFF"
    }
  }
});
